<template>
    <div  v-if="iconitem!=null">
        <a v-bind:href="'http://iconclass.org/rkd/'+iconitem.iconclass_external_id" target="_blank">
            <img class="ui mini rounded right floated image" src="/static/iconclass_v4.png" style="margin-bottom:20px;margin-top:5px;">
            Iconclass {{iconitem.iconclass_external_id}}
        </a><br>
        <span class="italic">{{iconitem.txt.en}}<br><br></span>
         <span class="italic" v-for="(subject, index) in iconitem.kws_all.en" :key="subject">{{subject}}<span v-if="index != iconitem.kws_all.en.length - 1">, </span></span><br><br>
        <!--<span v-for="topic in iconitem.kw.en" :key="topic" class="italic">{{topic}}, </span><br><br>-->
   </div>
</template>

<script>
    export default {
        props: ['iconid'],
        data() {
            return {
                iconitem: null
            }
        },

        methods: {
            hasOwnDeepProperty: function(obj, path) {
                for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
                    obj = obj[path[i]];
                    if (!obj) return false;
                };
                return true;
            },
        },

        mounted() {

            axios
                .get('/api/icon/' + this.iconid) //!!!!
                .then(response => (this.iconitem = response.data))
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .italic {
        font-style: italic;
    }
</style>



// WEBPACK FOOTER //
// src/components/TheIconClass.vue